/* eslint-disable react-hooks/rules-of-hooks */
'use client';
import Description from '@/components/Description';
import Octuple from '@/components/Octuple';
import PediaWorkBtn from '@/components/PediaWorkBtn';
import Title from '@/components/Title';
import VotingData from '@/components/VotingData';
import { IntroIcon } from '@/icons';
import defaultImage from '@/img/defaultImage.jpeg';
import { getDetail as getDetailAsync } from '@/service';
import isImageURL from '@/utils/isImageURL';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import Aside from './_components/Aside';
import styles from './page.module.scss';

export default function pediaPage() {
  const searchParams = useSearchParams();

  const [data, setData] = useState({});

  const getDetail = async (id) => {
    const { data } = await getDetailAsync({ lang: 1, id });
    document.title = `${data.name || data.mbti_profile}-MBTI`;
    setData(data);
  };

  useEffect(() => {
    getDetail(Number(searchParams.get('id')));
  }, [searchParams]);

  const {
    head = '',
    name = '',
    mbti_profile = '',
    // mbti_type = '',
    enneagram_type = '',
    works = '',
    subcategory = '',
    description = '',
    one = [],
    two = [],
    related = [],
  } = data;

  console.log('related', related);

  let { mbti_type } = data;
  if (mbti_type === 'XXXX' || mbti_type === '' || !mbti_type) {
    mbti_type = 'ESTP';
  }

  return (
    <main className={styles.pedia}>
      <article className={styles.pedia_article}>
        <section className={styles.pedia_article_intro}>
          <div className={styles.pedia_article_intro_img}>
            <Image
              src={isImageURL(head) ? head : defaultImage.src}
              width={128}
              height={128}
              alt={`mbti 百科(${name})头像`}
              style={{ borderRadius: 4 }}
            />
          </div>
          <div className={styles.pedia_article_intro_details}>
            <div className={styles.name}>
              <h1>
                <span>{name}</span>
                <span>{mbti_profile}</span>
              </h1>

              <h2>
                <span>{mbti_type}</span>
                <span>{enneagram_type}</span>
              </h2>
            </div>
            <PediaWorkBtn works={works} subcategory={subcategory} />
            <Octuple mbti_type={mbti_type} />
          </div>
        </section>

        <VotingData one={one} two={two} />

        <section className={styles.pedia_article_peopleInfo}>
          <Title>
            <IntroIcon />
            人物简介
          </Title>
          <Description words={description} />
        </section>
      </article>

      {/* <aside className={styles.pedia_aside}>
        <div className={styles.pedia_aside_title}>相关人物</div>
        <div className={styles.pedia_aside_related}>
          {(related || []).map(
            ({
              name = '',
              head = '',
              mbti_profile = '',
              mbti_type = 'ISFP',
              id = '',
            }) => (
              <div className={styles.pedia_aside_related_item} key={id}>
                <Avatar
                  head={head}
                  name={name}
                  mbti_profile={mbti_profile}
                  id={id}
                />

                <div className={styles.info}>
                  <div className={styles.info_name}>{name || mbti_profile}</div>
                  <div className={styles.info_mbti}>{mbti_type}</div>
                </div>
              </div>
            )
          )}
        </div>
      </aside> */}

      <Aside related={related} />
    </main>
  );
}
